module.exports = __webpack_public_path__ + "/login_ui/img/am-aebf3383562fb48109af9223c723682b.svg";